module.exports = "/images/ny-life2-11.jpg";